
import React from "react";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
export const InfoModal = (title,message) => {
    confirmAlert({
        title,
        message,
        buttons: [
            {
                label: "Ok",
                onClick: () => { },
            },
        ],
    });
};